// src/store/modules/toast.js

let toastTimer = null;

const state = {
  visible: false,
  message: '',
  type: 'info', // 'info', 'success', 'warning', 'error'
};

const mutations = {
  SET_TOAST(state, { message, type, visible }) {
    state.message = message;
    state.type = type;
    state.visible = visible;
  },
  CLEAR_TOAST(state) {
    state.message = '';
    state.visible = false;
    // Poderia resetar o 'type' para 'info' aqui se desejado
    // state.type = 'info';
  },
};

const actions = {
  showToast({ commit }, { message, type = 'info', duration = 5000 }) {
    if (toastTimer) {
      clearTimeout(toastTimer);
    }

    commit('SET_TOAST', { message, type, visible: true });

    if (duration > 0) { // Duração 0 ou negativa significa que o toast deve ser fechado manualmente
      toastTimer = setTimeout(() => {
        commit('CLEAR_TOAST');
        toastTimer = null;
      }, duration);
    }
  },

  hideToast({ commit }) {
    if (toastTimer) {
      clearTimeout(toastTimer);
      toastTimer = null;
    }
    commit('CLEAR_TOAST');
  },
};

const getters = {
  toastConfig: (state) => state,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
